import { useOrgIntegrationConnections } from "@/api/integrations";
import { useMemo } from "react";

export function useIntegrationConnection(
  name: string,
  provider?: "nango" | "pipedream",
) {
  const { data: allIntegrationConnections = [] } =
    useOrgIntegrationConnections();

  return useMemo(
    () =>
      allIntegrationConnections.find(
        (integration) =>
          integration.integration_platform === name &&
          (provider ? integration.integration_provider === provider : true),
      ),
    [allIntegrationConnections, name, provider],
  );
}
